import * as React from "react";
import TabbedPaperLayout, { TabbedPaperLayoutProps } from "./TabbedPaperLayout";
import RunbooksNavigationTabs from "../RunbooksNavigationTabs";
import StringHelper from "utils/StringHelper";

type RunbooksPaperLayoutProps = TabbedPaperLayoutProps;
const RunbooksPaperLayout: React.FC<RunbooksPaperLayoutProps> = ({ tabNavigation = RunbooksNavigationTabs, breadcrumbTitle = "Runbooks", title = StringHelper.ellipsis, ...rest }) => (
    <TabbedPaperLayout breadcrumbTitle={breadcrumbTitle} title={title} tabNavigation={tabNavigation} {...rest} />
);

export default RunbooksPaperLayout;
export { RunbooksPaperLayout };
